import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private token!: string;
    private httpOptions: any;
    helper = helper;

    private basePath = environment.interop.basePath;
    private notificationsUrl =
        this.basePath +
        environment.interop.dgaspc.notifications.authNotifications;

    private notificationSource = new Subject<{
        id: string;
        name: string;
    }>();
    currentNotification = this.notificationSource.asObservable();

    constructor(private http: HttpClient) { }

    async warningSwal(title: any, text: any, icon: any = 'warning') {
        return await Swal.fire({
            icon: icon,
            title: title,
            text: text,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: helper.dialogConfig.buttonLabels.close,
        });
    }

    async successSwal(title: any, text: any) {
        return await Swal.fire({
            icon: 'success',
            title: title,
            text: text,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: helper.dialogConfig.buttonLabels.close,
        });
    }

    async confirmSwal(title: any, text: any, confirmButtonText: string = 'Da', cancelButtonText: string = 'Nu') {
        return await Swal.fire({
            icon: 'question',
            title: title,
            text: text,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            reverseButtons: true,
        });
    }

    changeNotification(notification: { id: string; name: string }) {
        this.notificationSource.next(notification);
    }

    getNotifications() {
        return this.http
            .get(this.notificationsUrl, this.httpOptions)
            .pipe(map((response: any) => response.data));
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
